export const PHONE_TYPES = {
  MOBILE: {
    name: "mobile",
    value: "MOBILE",
  },
  HOME: {
    name: "home",
    value: "HOME",
  },
  WORK: {
    name: "work",
    value: "WORK",
  },
};
